import type { Contract } from '@/types/contracts'
import type { UserDocument } from '@/types/documents'
import type { RequestState } from '@/utils/restStore'
import { RequestStatus, handleRequest, initialRequestState } from '@/utils/restStore'
import { defineStore } from 'pinia'

import Api from '@/services/api'

interface State {
  documents: RequestState<UserDocument[]>
  insurancesCertificates: RequestState<Contract[]>
}

const initialState = (): State => ({
  documents: initialRequestState(),
  insurancesCertificates: initialRequestState()
})

export const useDocumentsStore = defineStore({
  id: 'documents',
  state: initialState,
  actions: {
    async fetchInsuranceCertificates() {
      await handleRequest(Api.getInsuranceCertificates, (insurancesCertificates: RequestState<Contract[]>) => {
        this.insurancesCertificates = insurancesCertificates
      })
    },
    async fetchB2BInsuranceCertificates(companyId: string) {
      await handleRequest(
        () => {
          return Api.getB2BInsuranceCertificates(companyId)
        },
        (insurancesCertificates: RequestState<Contract[]>) => {
          this.insurancesCertificates = insurancesCertificates
        }
      )
    },
    async fetchDocuments() {
      // docs to upload
      await handleRequest(Api.getDocuments, (documents: RequestState<UserDocument[]>) => {
        this.documents = documents
      })
    }
  },
  getters: {
    getAllDocuments: (state: State) => (): UserDocument[] => {
      return state.documents.status === RequestStatus.RequestLoaded ? state.documents.data : []
    }
  }
})
